import { styled } from '@mui/material/styles'

interface SeparatorProps {
  height: string
}

export const StyledSeparator = styled('div')<SeparatorProps>(
  ({ theme, height }) => ({
    borderLeft: '1px solid',
    marginLeft: 24,
    marginRight: 24,
    opacity: 0.34,
    height: height,
  })
)
